export const ROLES = [
  "visitor",
  "exhibitor",
  "delegate",
  "speaker",
  "media",
  "organizer",
  "crew",
  "workshop",
  "vip",
  "sponsor",
  "committee",
  "CTF",
  "CrisisSimulation",
  "staff",
  "volunteer",
  "panelist",
  "host",
  "moderator",
  "Hackathon",
  "DayPass",
  "Certificate",
  "visitorDay1",
  "visitorDay2",
  "Meeting",
  "OSHRM_Board_Members",
  "Corporates",
  "Student",
  "Vendors",
  "Board_Members",
  "ground_team",
  "positive_technology",
  "immersive_crisis_simulation",
  "participant",
  "facilitator",
  "nama_delegate",
  "nama_visitor",
  "member",
  "cigre_member",
  "non_cigre_member",
  "allied_health_nursing",
  "residents_interns_others",
  "physician_local",
  "physician_international",
  "administrator_local",
  "administrator_international",
  "physician",
  "administrator",
  // RHIC 2026 (client 2026-08-27): its own category beside Students, same fee ladder.
  // The value is the shared-DB table suffix ({eventId}_unemployed_graduates) and must match
  // what the registration form writes — the label shown to staff can change, this cannot.
  "unemployed_graduates",
  "lmics",
  "gulf_water_delegate",
  "delegate_day_1",
  "delegate_day_2",
  "gulf_water_visitor",
  "gulf_water_exhibitor",
  "gulf_water_organizer",
  "guest",
  "academic",
  "press",
  "networking",
  "media_1",
  "survey_staff",
  "exhibitor_1",
  // A tier above "vip", requested 2026-09-25. The value is the shared-DB table suffix
  // ({eventId}_VVIP) and must match the `events.roles` SET member and the ROLE enum in
  // api-admin byte-for-byte, casing included — the production host matches table names
  // case-sensitively, so a casing difference picks an empty shadow table instead of erroring.
  "VVIP",
];
